import React from 'react';
import Logo from '@/components/layout/Logo';

const skeletonBlock = 'rounded bg-slate-200 animate-pulse motion-reduce:animate-none';

/**
 * ZorgLandingPageSkeleton
 * Mirrors the structure of ZorgLandingPage.jsx
 */
const ZorgLandingPageSkeleton = () => {
  return (
    <div className="bg-slate-50 min-h-screen">
      {/* ─── Hero Skeleton ─── */}
      <section className="relative min-h-[90vh] flex items-center overflow-hidden">
        {/* Background blobs mirroring the real page */}
        <div className="absolute inset-0 bg-white" />
        <div className="absolute inset-0 bg-gradient-to-br from-blue-50/50 via-white to-indigo-50/30" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[600px] w-[600px] rounded-full bg-sky-400/10 blur-3xl" />

        <div className="relative z-10 mx-auto w-full max-w-4xl px-6 py-20 text-center">
          <div className="flex flex-col items-center">
            {/* Logo placeholder */}
            <div className="mb-10 opacity-50">
              <Logo size={48} />
            </div>

            {/* Subheading skeleton */}
            <div className={`${skeletonBlock} h-4 w-full max-w-lg mb-6`} />

            {/* Main title skeleton (2-line) */}
            <div className="space-y-4 mb-12">
              <div className={`${skeletonBlock} h-10 sm:h-12 w-full max-w-2xl mx-auto`} />
              <div className={`${skeletonBlock} h-10 sm:h-12 w-2/3 max-w-lg mx-auto`} />
            </div>

            {/* Hint text skeleton */}
            <div className={`${skeletonBlock} h-4 w-full max-w-md mb-8 bg-slate-100`} />

            {/* TargetingHighlights skeleton (3 pills) */}
            <div className="flex flex-wrap justify-center gap-4 rounded-full bg-white px-6 py-3 shadow-sm border border-slate-200">
              <div className={`${skeletonBlock} h-5 w-32`} />
              <div className="hidden sm:block h-4 w-px bg-slate-200" />
              <div className={`${skeletonBlock} h-5 w-28`} />
              <div className="hidden sm:block h-4 w-px bg-slate-200" />
              <div className={`${skeletonBlock} h-5 w-30`} />
            </div>

            {/* Form skeleton (Input + Button inline) */}
            <div className="mt-10 w-full max-w-md">
              <div className="flex gap-2">
                <div className={`${skeletonBlock} h-12 flex-1 rounded-xl bg-slate-100`} />
                <div className={`${skeletonBlock} h-12 w-32 rounded-xl bg-sky-100`} />
              </div>
              <div className="mt-4 flex justify-center">
                <div className={`${skeletonBlock} h-4 w-60 bg-slate-100`} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ZorgLandingPageSkeleton;
